let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("esJrS")).then(() => parcelRequire('1Ja9P'));